import SimplePageWrapper from 'components/misc/SimplePageWrapper'
import Image from 'components/elements/Image'

import styles from 'pages/missing-deck/missingDeck.module.scss'

const MissingFolderPage = () => {
  return (
    <SimplePageWrapper title="Missing folder - Archidekt" robots="noindex">
      <div className={styles.container}>
        <div className={styles.branding}>
          <Image alt="Archidekt basic logo" src="/images/archidekt_basic.svg" height={100} />
        </div>

        <h1>Unable to find this folder...</h1>

        <p>
          A folder with this ID could not be found. Double check that this folder still exists, and that you have
          permission to view it.
        </p>
      </div>
    </SimplePageWrapper>
  )
}

export default MissingFolderPage
